import { Tag } from "Components";
import { UserData } from "../CampaignReport.type";
import { RESULT_COLOR } from "../CampaignReport.constant";
import { capitalize } from "PhishingManager/utils";

const IndividualListItem = ({ userData }: { userData: UserData }) => {
    const { color: resultColor, bg: resultBg } = RESULT_COLOR[userData?.result || ''] || RESULT_COLOR.Failed;
    const properties = userData?.properties?.length > 1 ? userData?.properties?.length : capitalize(userData?.properties?.[0] || '-');
    const groups = userData?.groups?.length > 1 ? userData?.groups?.length : capitalize(userData?.groups?.[0] || '-');
    const name = `${userData.first_name || ""} ${userData.last_name || ""}`.trim();
    return <div className='list-item'>
        <div className='row'>
            <span className='title'>{name || ''}</span>
            <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>
                {userData?.result || ''}
            </Tag>
        </div>
        <div className='row'>
            <span className='description'><strong>Property: </strong>{properties}</span>
            <span className='description'><strong>Group: </strong>{groups}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Source: </strong>{userData?.source || ''}</span>
            <Tag className='status-tag' style={{ color: '#636766', background: '#EAEAEB' }}>
                {userData?.interaction || ''}
            </Tag>
        </div>
    </div>
}

export default IndividualListItem;